// extracted by mini-css-extract-plugin
export default {"formWrapperDesktop":"aYtMA0","formWrapperShadow":"bYtMA0"};